import React, {useEffect, useState} from "react";
import TableVirtualized from "../../../components/virtualized/virtualized";
import Box from "../../../components/box/Box";
import Head from "next/head";
import {getBahabinText, getTitleFaIranFinancialMarkets} from "../../../util/DominantUtil";
import axios from "../../../components/plugins/axios";

const GLOBAL_CSS = " text-light"

export default function Signal() {
//    const {authenticated} = useAuthenticated(state => ({authenticated: state.authenticated}))
    const [data, setData] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [searchData] = useState([]);
    const [dataCache, setDataCache] = useState(null);

    useEffect(() => {
        callApi();
    }, [])

    function callApi() {
        axios
            .get("/signals").then((response) => {
            let res = response.data;
            setData(res.data)
            setDataCache(res.data)
            setLastUpdate(res.lastUpdate)
            searchData.push('همه')
            res.data.map(s => searchData.push(s[0]))
        }).catch((error) => {
            console.log(error)
        });
    }

    function setBgClassName(value) {
        let digit = Math.round(value);
        digit = digit.toString().length;

        if (typeof value === "number") {
            if (value < 0) {
                if (value === -1) return "negative1 negative1-text"
                switch (digit) {
                    case 4:
                        return "negative5" + GLOBAL_CSS;
                    case 3:
                        return "negative4" + GLOBAL_CSS;
                    case 2:
                        return "negative3" + GLOBAL_CSS;
                    case 1:
                        return "negative2" + GLOBAL_CSS;
                    default:
                        if (digit >= 5) return "negative5" + GLOBAL_CSS;
                        return "neutral";
                }
            } else if (value > 0) {
                if (value === 1) return "positive1 positive1-text"
                switch (digit) {
                    case 4:
                        return "positive4" + GLOBAL_CSS;
                    case 3:
                        return "positive3" + GLOBAL_CSS;
                    case 2:
                        return "positive2" + GLOBAL_CSS;
                    case 1:
                        return "positive1" + GLOBAL_CSS;
                    default:
                        if (digit >= 5) return "positive5" + GLOBAL_CSS;
                        return "neutral";
                }
            }
            return "zero zero-text"
        }
    }

    function dropDownHandler(value) {
        value === 'همه' ? setData(dataCache) : setData(dataCache.filter(x => x[0] === value))
    }

    const properties = {
        sectors: searchData,
        lastUpdate: lastUpdate,
        disableLiveCircle: true,
        dropDownInputPlace: 'نماد',
        dropDownIconClassName: 'fa-landmark',
        dropDownHandler: dropDownHandler,
    };

    const tooltipSteps = [
        {
            target: '.extraDropDown',
            content: 'انتخاب نماد',
            placement: 'right',
        },
        {
            target: '.extra-last-update',
            content: 'زمان دقیق به روز رسانی',
        },
//        {
//            target: '.individuals-capitation',
//            content: 'زمان دقیق به روز رسانی',
//        },
//        {
//            target: '.individuals-money-flow',
//            content: 'زمان دقیق به روز رسانی',
//        },
//         {
//             target: '.queue-threshold',
//             content: 'زمان دقیق به روز رسانی',
//         },
//         {
//             target: '.last-close-diff',
//             content: 'زمان دقیق به روز رسانی',
//         },
//        {
//            target: '.liquidity-entrance',
//            content: 'زمان دقیق به روز رسانی',
//        },
    ]

    return (
        <Box uiActions={properties} title='سیگنال' loaded={lastUpdate && data}
             showRW={true}
             linksMap={{
                 'last': 'بازار بورس',
             }}
             height='930px'
             tooltipSteps={tooltipSteps}>
            <Head>
                <title>{getTitleFaIranFinancialMarkets('سیگنال لحظه ای') + getBahabinText()}</title>
            </Head>
            <TableVirtualized
                columns={columns}
                setBgClassName={x => setBgClassName(x)}
                customHeight={890}
                mutableData={data}
                keyField="0"
                defaultSortBy={'3'}
                defaultSortDirection={'DESC'}
            />
        </Box>
    )
}

const columns = [
    {
        title: "نماد",
        dataIndex: "0",
        type: 'link',
        sorter: true,
        checkbox: false,
        enable: true,
    },
    {
        title: "سرانه خرید/فروش",
        dataIndex: "1",
        sorter: true,
        checkbox: false,
        enable: true,
        className: 'individuals-capitation'
    },
    {
        title: "ورود/خروج پول هوشمند",
        dataIndex: "2",
        sorter: true,
        checkbox: false,
        enable: true,
        disableOnMobile: true,
        className: 'individuals-money-flow'
    },
    {
        title: "آستانه صف خرید/فروش",
        dataIndex: "3",
        sorter: true,
        checkbox: false,
        enable: true,
        disableOnMobile: true,
        className: 'queue-threshold'
    },
    {
        title: "آخرین-پایانی",
        dataIndex: "4",
        sorter: true,
        checkbox: false,
        enable: true,
        disableOnMobile: true,
        className: 'last-close-diff'
    },
    {
        title: "نقد شوندگی",
        dataIndex: "5",
        sorter: true,
        checkbox: false,
        enable: true,
        disableOnMobile: true,
        className: 'liquidity-entrance'
    }
];